/**
 * A última aba escolhida em cada conjunto de abas, lembrada neste navegador.
 *
 * Cada conjunto tem a sua chave (``persistKey`` do ``TabsRoot``), gravada em
 * ``prism.tabs.<persistKey>.active`` — o mesmo prefixo da ordem arrastada
 * (``prism.tabs.<key>.order``), então um uso de abas é uma chave só. Sem
 * ``localStorage`` (aba privada, armazenamento bloqueado) a tela só volta a
 * abrir na aba padrão.
 */

type KeyValueStore = Pick<Storage, 'getItem' | 'setItem'>

function browserStorage(): KeyValueStore | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function rememberedTabKey(persistKey: string): string {
  return `prism.tabs.${persistKey}.active`
}

/**
 * A aba guardada para ``persistKey``, se ela ainda for uma das ``allowed``.
 * Sem ``allowed`` devolve o que estiver guardado: quem chama confere.
 */
export function readRememberedTab<T extends string>(
  persistKey: string,
  allowed?: readonly T[],
  storage = browserStorage(),
): T | null {
  let raw: string | null
  try {
    raw = storage?.getItem(rememberedTabKey(persistKey)) ?? null
  } catch {
    return null
  }
  if (!raw) return null
  if (allowed && !(allowed as readonly string[]).includes(raw)) return null
  return raw as T
}

export function rememberTab(persistKey: string, value: string, storage = browserStorage()): void {
  try {
    storage?.setItem(rememberedTabKey(persistKey), value)
  } catch {
    // Sem storage (aba privada, cota): a tela segue funcionando sem lembrar.
  }
}
